import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, BACKEND } from "@/lib/api";
import { STRINGS } from "@/i18n/strings";

const SiteCtx = createContext(null);

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export function SiteProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rk_lang") || "id");
  const [site, setSite] = useState(null);
  const [draft] = useState(() => new URLSearchParams(window.location.search).get("preview") === "1" || sessionStorage.getItem("rk_preview") === "1");
  useEffect(() => { if (draft) sessionStorage.setItem("rk_preview", "1"); }, [draft]);
  const refresh = useCallback(() => {
    api.get("/public/site", { params: draft ? { lang, draft: true } : { lang } }).then((r) => setSite(r.data)).catch(() => setSite((s) => s || false));
  }, [lang, draft]);
  useEffect(() => {
    document.documentElement.lang = lang === "zh" ? "zh-CN" : lang;
    refresh();
  }, [lang, refresh]);
  const setLang = (l) => {
    localStorage.setItem("rk_lang", l);
    setLangState(l);
  };
  const t = useCallback((k) => STRINGS[lang]?.[k] ?? STRINGS.id[k] ?? k, [lang]);
  return <SiteCtx.Provider value={{ lang, setLang, t, site, refresh, draft }}>
      {draft && !window.location.pathname.startsWith("/admin") && (
        <div className="fixed bottom-0 left-0 z-[60] flex items-center gap-3 bg-[#0F2B48] px-4 py-2 font-mono text-xs text-white" data-testid="preview-mode-banner">
          MODE PRATINJAU — menampilkan perubahan yang belum dipublikasikan
          <button onClick={() => { sessionStorage.removeItem("rk_preview"); window.location.href = "/"; }} className="underline" data-testid="preview-exit-button">Keluar</button>
        </div>
      )}
      {children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
